
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"30","height":"30","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_3564_29108)"}},[_c('path',{attrs:{"d":"M21.705 3.53v1.764h2.912v21H5.382v-21h2.912V3.53H3.617v24.53h22.765V3.529h-4.677z","fill":"#fff"}}),_c('path',{attrs:{"d":"M16.412 2.824c0-.795-.618-1.412-1.412-1.412-.794 0-1.412.617-1.412 1.412H9.971v3.264h10.147V2.824h-3.706z","fill":"#fff"}}),_c('path',{attrs:{"d":"M14.294 9.794l-4.059 4.147-2.206-2.206","stroke":"#fff","stroke-width":"1.2","stroke-miterlimit":"10"}}),_c('path',{attrs:{"d":"M13.148 17.559l-.618-.618-2.03 2.03-2.029-2.03-.617.618 2.029 2.03-2.03 2.029.618.617 2.03-2.03 2.029 2.03.618-.617-2.03-2.03 2.03-2.03z","fill":"#fff"}}),_c('path',{attrs:{"d":"M14.648 12.882h7.589M14.648 19.676h7.589","stroke":"#fff","stroke-width":"1.2","stroke-miterlimit":"10"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_3564_29108"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h30v30H0z"}})])])])
          )
        }
      }
    